import {
  PURCHASE_CONFIRMATION_START,
  PURCHASE_CONFIRMATION_SUCESS,
  PURCHASE_CONFIRMATION_ERROR,
  CLEAR_PURCHASE_CONFIRMATION,
  GTRES_PURCHASE_START,
  GTRES_PURCHASE_SUCCESS,
  GTRES_PURCHASE_ERROR,
} from 'actions/payway';

const initialState = {
  inProgress: false,
  success: null,
  error: null,
  data: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PURCHASE_CONFIRMATION_START: {
      return {
        inProgress: true,
        success: null,
        error: null,
        data: null,
      };
    }
    case PURCHASE_CONFIRMATION_SUCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case PURCHASE_CONFIRMATION_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    case CLEAR_PURCHASE_CONFIRMATION: {
      return {
        ...initialState,
      };
    }
    case GTRES_PURCHASE_START: {
      return {
        ...initialState,
        inProgress: true,
      };
    }
    case GTRES_PURCHASE_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case GTRES_PURCHASE_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    default: {
      return state;
    }
  }
}
